
import { AdminKeys } from '@/i18n/types/admin.types';

export const admin: Record<AdminKeys, string> = {
  adminPanel: 'Panel de Administración',
  productManagement: 'Gestión de Productos',
  createProduct: 'Crear Producto',
  editProduct: 'Editar Producto',
  deleteProduct: 'Eliminar Producto',
  productName: 'Nombre del Producto',
  productDescription: 'Descripción del Producto',
  productPrice: 'Precio',
  productCurrency: 'Moneda',
  productImage: 'Imagen del Producto',
  isActive: 'Está Activo',
  uploadImage: 'Subir Imagen',
  removeImage: 'Eliminar Imagen',
  saveProduct: 'Guardar Producto',
  cancelEdit: 'Cancelar',
  confirmDelete: 'Confirmar Eliminación',
  deleteConfirmMessage: '¿Estás seguro de que quieres eliminar este producto? Esta acción no se puede deshacer.',
  productCreated: 'Producto creado exitosamente',
  productUpdated: 'Producto actualizado exitosamente',
  productDeleted: 'Producto eliminado exitosamente',
  errorCreatingProduct: 'Error al crear producto',
  errorUpdatingProduct: 'Error al actualizar producto',
  errorDeletingProduct: 'Error al eliminar producto',
  errorUploadingImage: 'Error al subir imagen',
  requiredField: 'Este campo es requerido',
  invalidPrice: 'Por favor ingresa un precio válido',
  adminAccessRequired: 'Se requiere acceso de administrador',
  loadingProducts: 'Cargando productos...',
  noProductsFound: 'No se encontraron productos',
  actions: 'Acciones',
  edit: 'Editar',
  delete: 'Eliminar',
  active: 'Activo',
  inactive: 'Inactivo',
  dragImageHere: 'Arrastra la imagen aquí',
  orClickToSelect: 'o haz clic para seleccionar',
  imageUploaded: 'Imagen subida exitosamente',
  maxFileSize: 'Tamaño máximo: 5MB',
  allowedFormats: 'Formatos permitidos: JPG, PNG, WebP',
  administration: 'Administración',
  adminProducts: 'Admin: Productos',
  adminFeatures: 'Admin: Características',
};
